<template>
  <div>
    <div>
      <el-button type="primary" size="mini" :icon="btnInfo.icon" @click="getcc" style="margin-bottom: 6px">{{
        btnInfo.label }}</el-button>
    </div>
    <component :is="getComp" :tableInfo="tableInfo" @create="setTableInfo" />
    <!-- <el-dialog>
            <  />
        </el-dialog> -->
  </div>
</template>

<script>
import TableGenerate from "./tableGenerate.vue";
import TableCollect from "./tableCollect.vue";

export default {
  data() {
    return {
      getComp: "TableCollect",
      tableInfo: {},
      btnObj: {
        TableCollect: { label: "新增", icon: "el-icon-circle-plus-outline" },
        TableGenerate: { label: "返回", icon: "el-icon-refresh-left" },
      },
    };
  },
  computed: {
    btnInfo() {
      return this.btnObj[this.getComp];
    },
  },
  components: { TableCollect, TableGenerate },
  mounted() { },
  methods: {
    setTableInfo(data) {
      this.tableInfo = data;
      this.getCreate();
    },
    getcc() {
      this.tableInfo = {};
      this.getCreate();
    },
    getCreate() {
      const arr = ["TableCollect", "TableGenerate"];
      const index = 1 - arr.indexOf(this.getComp);
      this.getComp = arr[index];
    },
  },
};
</script>

<style></style>